// "Before you start" at the top of a bought property's page (Neil, 10 Oct 2026: "any red flag we
// need to highlight"; 13 Oct 2026: never "red flags" to customers, "Before you start" with an
// info circle in amber), the same list as the pack's page of the same name (100-api
// common/red_flags.py, still "red flags" in code). Only shown when there's one. "Check before
// approaching" in red, "Plan for it" in orange, each with what we found and what to do.
import { CircleAlert, Info } from "lucide-react";
import type { RedFlag } from "../api";

export function RedFlags({ flags }: { flags?: RedFlag[] }) {
  if (!flags?.length) return null;
  const stops = flags.filter((f) => f.severity === "stop").length;
  return (
    <section className="card rf" aria-labelledby="rf-title">
      <header className="airoof-head">
        <span className="airoof-mark rf-mark" aria-hidden="true">
          <Info size={22} />
        </span>
        <div className="airoof-title">
          <h2 id="rf-title">Before you start</h2>
          <p className="muted">
            {flags.length} thing{flags.length === 1 ? "" : "s"} to know before you contact them or plan the system
            {stops ? `; ${stops === 1 ? "the first needs" : `the first ${stops} need`} checking before you approach them` : ""}.
          </p>
        </div>
      </header>
      <div className="rf-list">
        {flags.map((f) => {
          const Icon = f.severity === "stop" ? CircleAlert : Info;
          return (
            <div key={f.key} className={`rf-item is-${f.severity}`}>
              <span className="rf-icon" aria-hidden="true">
                <Icon size={20} />
              </span>
              <div>
                <div className="rf-title">
                  {f.title}
                  <span className="rf-sev">{f.severity === "stop" ? "Check before approaching" : "Plan for it"}</span>
                </div>
                {f.what && <p className="rf-what">{f.what}</p>}
                <p className="rf-do">
                  <b>What to do:</b> {f.todo}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {/* Where they came from, as the report's Before you start page says */}
      <p className="muted eo-note">Found by our checks, the roof analysis and the research. Everything else in this report assumes they are resolved.</p>
    </section>
  );
}
